/* Dalen — open mega-menu / dropdown menus on hover instead of click.
   Each menu lives inside a <header-menu> custom element containing a
   <details> with a <summary>. We toggle the details' `open` attribute on
   mouseenter / mouseleave with a small close delay so users can move the
   cursor down into the panel without it snapping shut. */
(function () {
  var CLOSE_DELAY = 120;

  function init() {
    var menus = document.querySelectorAll('header-menu');
    menus.forEach(function (menu) {
      if (menu.dataset.dalenHover) return;
      menu.dataset.dalenHover = 'true';

      var details = menu.querySelector('details');
      if (!details) return;

      var summary = details.querySelector('summary');
      var closeTimer = null;

      function open() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        // Close any other open menus first
        document.querySelectorAll('header-menu details[open]').forEach(function (d) {
          if (d !== details) d.removeAttribute('open');
        });
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }
      }

      function scheduleClose() {
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
        }, CLOSE_DELAY);
      }

      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', scheduleClose);

      // Keep click-to-toggle working for keyboard / touch — but don't
      // double-fire when a hover has already opened it.
      if (summary) {
        summary.addEventListener('click', function (e) {
          // If the menu is already open via hover, treat click as navigation
          // to the summary's target (no preventDefault needed).
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
